import { useEffect, useState } from "react";

import { Card } from "../../../../components/Card";
import { api } from "../../../../services/api";
import { AxiosError } from "axios";
import { ButtonListButton } from "../../../../components/organisms/ButtonListBox";
import { useQuery } from "../../../../hooks/query";
import { useNavigate } from "react-router-dom";
import { Table } from "../../../../components/templates/Table";
import { DeleteModal } from "../../../../components/templates/DeleteModal";
import { InternalHeader } from "../../../../components/templates/InternalHeader";
import { MerchandiseModal } from "../../../../components/templates/Modal/MerchandiseModal";
import { EditModalButton } from "../../../../components/molecules/TableListButton/EditModalButton";
import { AddButtonWithTextModal } from "../../../../components/molecules/AddButtonWithTextModal";

interface Merchandise {
  id: string;
  name: string;
  merchandise_subcategory_id: string;
  measurement_unit: string;
  merchandise_subcategory: {
    name: string;
  };
}

interface MerchandiseSubcategory {
  id: string;
  name: string;
}
interface Params {
  page: number;
  limit_per_page: number;
  search: string;
  order_column?: string;
  order_type?: string;
}

export function ListMerchandises() {
  const query = useQuery();
  const navigate = useNavigate();
  const [merchandises, setMerchandises] = useState<Merchandise[]>([]);
  const [merchandiseSubcategories, setMerchandiseSubcategories] = useState<
    MerchandiseSubcategory[]
  >([]);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState<number>(0);
  const [isOpen, setIsOpen] = useState(false);
  const [actionType, setActionType] = useState<"create" | "edit">("create");
  const [defaultValue, setDefaultValue] = useState<Merchandise>(
    {} as Merchandise
  );
  const [defaultParams, setDefaultParams] = useState<Params>({
    limit_per_page: query.get("limit") ? Number(query.get("limit")) : 10,
    page: query.get("offset") ? Number(query.get("offset")) : 1,
    search: query.get("search") ?? "",
    order_column: query.get("order_column") ?? "",
    order_type: query.get("order_type") ?? "",
  });

  useEffect(() => {
    api
      .get(
        `pricing/merchandises/pagination?offset=${defaultParams.page}&limit=${defaultParams.limit_per_page}&search=${defaultParams.search}&order_column=${defaultParams.order_column}&order_type=${defaultParams.order_type}`
      )
      .then((response) => {
        setMerchandises(response.data.merchandises);
        setTotal(response.data.total);
        setLoading(true);
      })
      .catch((err: AxiosError) => {
        navigate(`/error/${err.response?.status}`);
      });
  }, [navigate, defaultParams]);

  useEffect(() => {
    api
      .get("pricing/merchandiseSubcategories")
      .then((response) => setMerchandiseSubcategories(response.data));
  }, []);

  return (
    <>
      <InternalHeader
        title="Mercadoria"
        has_back_button={true}
        has_filter={false}
      >
        <AddButtonWithTextModal
          onClick={() => {
            setIsOpen(true);
            setActionType("create");
            setDefaultValue({
              id: "",
              name: "",
              measurement_unit: "",
              merchandise_subcategory: { name: "" },
              merchandise_subcategory_id: "",
            });
          }}
        />
      </InternalHeader>
      <MerchandiseModal
        merchandiseSubcategories={merchandiseSubcategories}
        isOpen={isOpen}
        setIsOpen={(value) => setIsOpen(value)}
        actionType={actionType}
        defaultValue={defaultValue}
        defaultLink="pricing/merchandises"
        setMerchandise={(merchandise) => {
          if (actionType === "create") {
            setMerchandises([...merchandises, merchandise]);
          } else {
            setMerchandises(
              merchandises.map((c) => {
                if (c.id === merchandise.id) {
                  return merchandise;
                }
                return c;
              })
            );
          }
        }}
      />
      <Card
        body={
          <Table
            loading={loading}
            message="Buscando as mercadorias"
            params={defaultParams}
            setDefaultParams={(params) => {
              setDefaultParams(params);
              navigate(
                `/precificacao/mercadoria?offset=${params.page}&limit=${params.limit_per_page}&search=${params.search}&order_column=${params.order_column}&order_type=${params.order_type}`
              );
            }}
            total={total}
            data={merchandises.map((merchandise) => {
              return {
                tr: [
                  {
                    name: merchandise.name,
                  },
                  {
                    name: merchandise.measurement_unit,
                  },
                  {
                    name: merchandise.merchandise_subcategory.name,
                  },
                  {
                    name: (
                      <ButtonListButton>
                        <EditModalButton
                          onClick={() => {
                            setActionType("edit");
                            setIsOpen(true);
                            setDefaultValue(merchandise);
                          }}
                        />

                        <DeleteModal
                          onDelete={(id) => {
                            setMerchandises(
                              merchandises.filter(
                                (merchandise) => merchandise.id !== id
                              )
                            );
                          }}
                          id={merchandise.id}
                          route="pricing/merchandises/"
                          error_message="Não foi possível remover a mercadoria"
                          success_message="Mercadoria removida com sucesso"
                        />
                      </ButtonListButton>
                    ),
                  },
                ],
              };
            })}
            columns={[
              {
                name: "name",
                label: "Nome",
                options: {
                  sort: true,
                },
              },
              {
                name: "measurement_unit",
                label: "Unidade",
                options: {
                  sort: true,
                },
              },
              {
                name: "merchandise_subcategories",
                label: "Subcategoria",
                options: {
                  sort: true,
                },
              },
              {
                name: "action",
                label: "Ações",
                options: {
                  sort: false,
                },
              },
            ]}
          />
        }
      />
    </>
  );
}
